import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-personal-skill-activity-staff-map',
  templateUrl: './personal-skill-activity-staff-map.component.html',
  styleUrls: ['./personal-skill-activity-staff-map.component.css']
})
export class PersonalSkillActivityStaffMapComponent implements OnInit {
  dropdownSettings: any = {};
  selectedItems: any = [];
  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  PersonalSkillActivityStaffMapModel = {
    StaffID: 0,
    ClassID: 0,
    SectionID: 0,
    ClassSectionID: null,
    ActivitySkill: '',
    ExamActStaffMapIDs: '',
    PersonalActivityList:[]

}

IsAllSelect = false;


ClassSectionSplit  () {
    this.PersonalSkillActivityStaffMapModel.ClassID = 0;
    this.PersonalSkillActivityStaffMapModel.SectionID = 0;
    if (this.PersonalSkillActivityStaffMapModel.ClassSectionID != 0 || this.PersonalSkillActivityStaffMapModel.ClassSectionID != null) {
        var strClassSectionID = this.PersonalSkillActivityStaffMapModel.ClassSectionID.split('-');
        this.PersonalSkillActivityStaffMapModel.ClassID = strClassSectionID[0];
        this.PersonalSkillActivityStaffMapModel.SectionID = strClassSectionID[1];
    }
    this.GetAllPersonalActivity();
}
PersonalActivitySkilltList:any;
GetPersonalSkillActivityStaffMap  () {
    this.spinnerService.show();
    this.examService.GetPersonalSkillActivityStaffMap(JSON.stringify(this.PersonalSkillActivityStaffMapModel)).subscribe( (data)=> {
        this.PersonalActivitySkilltList = data.PersonalActivitySkilltList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
    })
}
PersonalActivityList:any;
SavePersonalSkillActivityStaffMap  () {
    var ActivitySkill = '';
    var PersonalActivityList = this.PersonalSkillActivityStaffMapModel.PersonalActivityList;
    for (var i = 0; i < PersonalActivityList.length; i++) {
        if ( ActivitySkill == '') {
            ActivitySkill = PersonalActivityList[i].ItemId;
        }
        else  {
            ActivitySkill = ActivitySkill + "," + PersonalActivityList[i].ItemId;
        }
    }
    this.PersonalSkillActivityStaffMapModel.ActivitySkill = ActivitySkill;
    this.examService.SavePersonalSkillActivityStaffMap(JSON.stringify(this.PersonalSkillActivityStaffMapModel)).subscribe( (data)=> {
        this.Clear();
        this.globalHelper.CheckActionStatus(data);
        this.GetPersonalSkillActivityStaffMap();
    });
}

Clear  () {
    this.PersonalSkillActivityStaffMapModel.StaffID = 0;
    this.PersonalSkillActivityStaffMapModel.ClassSectionID = null;
    this.PersonalActivityList = {};
}
StaffList:any;
GetAllStaff  () {
    this.lookupService.GetLookupsList(' StaffName', '').subscribe( (data)=> {
        this.StaffList = data.LookupItems;
    });
};
ClassSectionList:any;
GetAllClassSection  () {
    this.lookupService.GetLookupsList('ClassSectionListKG', '').subscribe( (data)=> {
        this.ClassSectionList = data.LookupItems;
    });
};

AllSelectChecked  () {
    for (var i = 0; i < this.PersonalActivitySkilltList.length; i++) {
        if (this.IsAllSelect) {
            this.PersonalActivitySkilltList[i].IsSelect = true;
        }
        else if (this.IsAllSelect == false) {
            this.PersonalActivitySkilltList[i].IsSelect = false;
        }
    }
}

AnyUnCheked  () {
    for (var i = 0; i < this.PersonalActivitySkilltList.length; i++) {
        if (this.PersonalActivitySkilltList[i].IsSelect == false) {
            this.IsAllSelect = false;
            break;
        }
    }
    var count = 0;
    for (var j = 0; j < this.PersonalActivitySkilltList.length; j++) {
        if (this.PersonalActivitySkilltList[j].IsSelect == true) {
            count++;
        }
    }
    if (count == this.PersonalActivitySkilltList.length) {
        this.IsAllSelect = true;
    }
}

DeletePersonalSkill  () {
    var ExamActStaffMapIDs = '';
    var PersonalActivityList = this.PersonalActivitySkilltList;
    for (var i = 0; i < PersonalActivityList.length; i++) {
        if (PersonalActivityList[i].IsSelect && ExamActStaffMapIDs == '') {
            ExamActStaffMapIDs = PersonalActivityList[i].ExamActStaffMapID;
        }
        else if (PersonalActivityList[i].IsSelect) {
            ExamActStaffMapIDs = ExamActStaffMapIDs + "," + PersonalActivityList[i].ExamActStaffMapID;
        }
    }
    this.PersonalSkillActivityStaffMapModel.ExamActStaffMapIDs = ExamActStaffMapIDs;
    this.examService.DeletePersonalSkill(this.PersonalSkillActivityStaffMapModel.ExamActStaffMapIDs).subscribe( (data)=> {
        this.globalHelper.CheckActionStatus(data);
        this.GetPersonalSkillActivityStaffMap();
    })
}

GetAllPersonalActivity  () {
    var itemBO = {
        'ItemId': this.PersonalSkillActivityStaffMapModel.ClassID,
        'ItemId1': this.PersonalSkillActivityStaffMapModel.SectionID,
        'ItemId2': this.PersonalSkillActivityStaffMapModel.StaffID
    };
    this.lookupService.GetLookupsList('PersonalSkillPersonalActivity', JSON.stringify(itemBO)).subscribe( (data)=> {
        this.PersonalActivityList = data.LookupItems;
        this.PersonalActivityList.splice(0, 1);
    });
};


  ngOnInit() {
    this.GetAllStaff();
    this.GetAllClassSection();
    this.GetAllPersonalActivity();
    this.GetPersonalSkillActivityStaffMap();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
  }

}
